import { render, staticRenderFns } from "./MenuButtonList.vue?vue&type=template&id=0c152c39"
import script from "./MenuButtonList.vue?vue&type=script&lang=js"
export * from "./MenuButtonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c152c39')) {
      api.createRecord('0c152c39', component.options)
    } else {
      api.reload('0c152c39', component.options)
    }
    module.hot.accept("./MenuButtonList.vue?vue&type=template&id=0c152c39", function () {
      api.rerender('0c152c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/MenuButtonList.vue"
export default component.exports